// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import clockIcon from "@/assets/icons/clock.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ClockIconProps = Omit<IconProps, "name">;

export function ClockIcon(props: ClockIconProps): React.ReactNode {
  return <Icon name={clockIcon} {...props} />;
}
